// @flow
import Nothing from './Nothing';

export default Nothing;
